// extracted by mini-css-extract-plugin
export default {"root":"styles_root__AufNG","grid-layout":"styles_grid-layout__b2Qzg","grid-item":"styles_grid-item__H7M7u","header":"styles_header__p2MV-"};